<template>
    <div class="about">
        <div class="top-white-box">
            <div class="top-gray-box">
                <h1>About Us</h1>
            </div>
        </div>
        <div class="page-wrapper">
            <div class="page-contents">
                <p class="text-center"><img :src="settings.logoUrl" class="about-logo"></p>
                <p v-for="(paragraph, index) in settings.aboutUs" :key="index" v-html="paragraph"></p>
                <p><a class="button" href="/JoinWhatsApp" target="_blank" @click="joinWhatsApp()">Join {{settings.siteNameCaps}}</a></p>
            </div>
        </div>
    </div>
</template>
<script>
    import settings from '@/settings'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'
    export default {
        created() {
            document.title = settings.siteNameCaps + ' | About';
        },
        computed: {
            settings: function () { return settings; }
        },
        methods: {
            joinWhatsApp() {
                ga.event('click', { 'event_category': 'whatsapp', 'event_label': 'whatsapp', 'transport_type': 'beacon' });
                clicky.goal("JoinWhatsApp2")
            }
        }
    }
</script>